@if (options.closeButton) {
  <button (click)="remove()" type="button" class="toast-close-button" aria-label="Close">
    <mat-icon svgIcon="pq:close"></mat-icon>
  </button>
}
@if (title) {
  <div [class]="options.titleClass" [attr.aria-label]="title">
    {{ title }} 
    @if (duplicatesCount) {
      [{{ duplicatesCount + 1 }}]
    }
</div>
}
@if (message && options.enableHtml) {
  <div role="alertdialog" aria-live="polite"
    [class]="options.messageClass" [innerHTML]="message">
  </div>
}
@if (message && !options.enableHtml) {
  <div role="alertdialog" aria-live="polite"
    [class]="options.messageClass" [attr.aria-label]="message">
    {{ message }}
  </div>
}
@if (options.progressBar) {
  <div>
    <div class="toast-progress" [style.width]="width + '%'"></div>
  </div>
}